/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useRef, useState,useEffect, useCallback, useContext } from 'react';
import { Link, useSearchParams } from 'react-router-dom'
import CardHeader from '../../../../components/CardHeader';
import Loader from '../../../../components/Loader';
import Toast from '../../../../components/Toast';
import Shimmer from '../../../../components/Shimmer/itemShimmer';
import SearchEmptyScreen from '../../../../components/SearchEmptyScreen';
import EmptyAddScreen from '../../../../components/EmptyAddScreen';
import Table from './Components/Table';
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import Debounce from '../../../../CommonMethods/Debounce';
import { dataService } from '../../../../services/data.services';
import { GetBranchId } from '../../../../CommonMethods/GetBranchId';
import GlobalContext from '../../../../components/Context/GloablContext';
import Filter from './../../TopBarComponents/Filter'
import Search from '../../TopBarComponents/Search';
import moment from 'moment';

const GRNList = () => {
    const {setToastmessage, isInactiveBranch, reloadFY, setReloadFY} = useContext(GlobalContext);
    const [searchParams, setSearchParams] = useSearchParams()
    const [toastErrorMessage, setToastErrorMessage] = useState("")
    const [GRNList, setGRNList] = useState([])
    const [GRNListCount, setGRNListCount] = useState(0)
    const [GRNListTotalCount, setGRNListTotalCount] = useState(0)
    const [loading, setLoading] =useState(true) 
    const [searchFieldDebounce, setsearchFieldDebounce] = useState(searchParams.get('search') === null ? '' : decodeURIComponent(searchParams.get('search')));
    const [FilterData, setFilterData] = useState({date_range : []});
    const [filterCount, setFilterCount] = useState(0)
    const [FilterCheckbox, setFilterCheckBox] = useState({})
    const [selectedFilter, setSelectedFilter] = useState(Object.keys(FilterData !==undefined&& FilterData)[0]||'city');
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [placeholderIndex, setPlaceholderIndex] = useState(0);
    const [selectedDateRange, setSelectedDateRange] = useState(searchParams.get('dropname') !== null ? searchParams.get('dropname') : 'Financial Year')
    const [selectedName, setSelectedName] = useState(searchParams?.get('main') !== null ? searchParams?.get('main'):'')  ;
    const [currentFinacialYear, setCurrentFinacialYear] = useState('')
    const [finacialYear, setFinacialYear] = useState('')
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [FYLoading, setFYLoading] = useState(true);
    const placeholderOptions = [
        'GRN #',
        'PO #',
        'Vendor Name',
        'Vendor Invoice #'
    ];

    const outSideClick = useRef();
    /**
     * The `formatDate` function takes an input date string and returns it in the format "YYYY-MM-DD".
     * @returns The function `formatDate` returns a formatted date string in the format "YYYY-MM-DD".
     */
    const formatDate = (inputDateString) => {
        const inputDate = new Date(inputDateString);
        const year = inputDate.getFullYear();
        const month = String(inputDate.getMonth() + 1).padStart(2, '0');
        const day = String(inputDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    
    //Fliter Functions----
    /**
     * The function `updateFilterCheckBox` creates an object with non-null properties from searchParams,
     * filters out null or undefined values, updates the state with the filtered values, and counts the
     * number of filtered values.
     */
    const updateFilterCheckBox = () => {
        // Create an object with non-null properties from searchParams
        const filterState = {
            start_date: searchParams.get('start_date'),
            end_date: searchParams.get('end_date'),
            status: searchParams.get('status')
        };
            // Filter out null or undefined values
        const filteredFilterState = Object.fromEntries(
            Object.entries(filterState).filter(([_, value]) => value !== null && value !== undefined)
        );
                
        // Update the state with the filtered values
        setFilterCheckBox(filteredFilterState);
        let count = 0
        Object.keys(filteredFilterState).map((item) =>  {
            if(filteredFilterState[item] &&filteredFilterState[item]?.length !== 0 && item!="end_date") {
                count += 1
            }
        })
        setFilterCount(count)
    };
    /**
     * The function `getCount` counts the number of non-empty values in the `FilterCheckbox` object and
     * updates the `filterCount` state variable accordingly.
     */
    const getCount = (type) => {
        let count = 0
        Object.keys(FilterCheckbox).map((item) =>  {
            if(FilterCheckbox[item] &&FilterCheckbox[item]?.length !== 0 && item!="end_date") {
                count += 1
            }
        })
        if(type) {
            setFilterCount(count)
        } else {
            setFilterCount(0)
        }
    }
    
    /**
     * The function `handleOpenFilter` updates the filter values based on the search parameters and toggles
     * the filter open state.
     */
    const handleOpenFilter = () => {
        let filter_val = {}
        Object.keys(FilterData).map((item) => {
            let params = Object.fromEntries(searchParams);
            Object.keys(params).map((subitem) => {
                if(item === subitem) {
                    filter_val[item] = params[item].split(',')
                }
                if(subitem==='start_date' ||subitem==='end_date'){
                    filter_val[subitem]=params[subitem]
                }
            })
            setFilterCheckBox(filter_val)      
        })
        setIsFilterOpen((prevState)=> !prevState)
        setSelectedFilter('date_range')
        setSelectedName(searchParams?.get('main') !== null ? searchParams?.get('main') : currentFinacialYear)
        setSelectedDateRange(searchParams.get('dropname') !== null ? searchParams.get('dropname') : 'Financial Year')
    }
    /* The `useOnClickOutside` is a custom hook that is used to detect clicks outside of a specific
    element. In this case, it is used to detect clicks outside of the filter component. When a click is
    detected outside of the filter component, the callback function `() => { setIsFilterOpen(false) }`
    is executed, which sets the `isFilterOpen` state to `false`, closing the filter component. */
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    /**
     * The function `handleSelectObject` updates the state of `FilterCheckbox` based on the selected
     * object's id, dateString, and selectedFilter.
     */
    const handleSelectObject = (id,dateString,selectedFilter) => {
        if(id === 'start_date' || id === 'end_date') {
            setFilterCheckBox((prv)=>({
                ...prv,
                [id]: dateString
            }))
        }  else {
            setFilterCheckBox((prv)=>({
                ...prv,
                [selectedFilter]:[id]
            }))
        } 
    }
    /**
     * The function `handleApplyFilter` is used to apply filters to a search query and update the search
     * parameters accordingly.
     */
    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        if(type && Object.keys(FilterCheckbox).length !==0) {
            params.main = selectedName
            if (selectedName === 'Custom') {
                if((FilterCheckbox['start_date']!==null && FilterCheckbox['end_date']!==null)){
                    params.dropname = 'Custom';
                } else {
                    setSearchParams({...params})
                }
            } else if (selectedName.includes('FY')) {
                params.dropname = 'Financial Year';
            }
            setSearchParams({ ...params})
            let flag = true;
            params["filter"] = true
            params.page_number = 1
            Object.keys(FilterCheckbox).map((item) => {
                let val = ""
                if((item === 'start_date' || item === 'end_date') && FilterCheckbox[item]!==null) {
                    let val = FilterCheckbox[item]
                    params[item] = searchParams.get(item) !== val ? formatDate(val) : val
                    setSearchParams({ ...params})
                    flag = false
                } else if(FilterCheckbox[item] && FilterCheckbox[item]?.length !== 0 ) {
                    FilterCheckbox[item].map((key) => {
                        val += `${key},`
                    })
                    params[item] = val.slice(0, -1)
                    setSearchParams({ ...params})
                    flag = false
                } else {
                    delete params[item] 
                    setSearchParams({ ...params})  
                }
                if(flag) {
                    delete params.filter
                    setSearchParams({ ...params})  
                }
            })
        } else {
            const searchParam = searchParams.get('search');
            searchParam !== null ? setSearchParams({'search': searchParam}) : setSearchParams({}); 
            setSelectedDateRange('Financial Year')
            if(reloadFY)
            {
                const selectedFY = JSON.parse(localStorage.getItem('FY_details'));
                setCurrentFinacialYear(selectedFY.name)
                if (selectedFY) {
                    setStartDate(selectedFY.start_date);
                    setEndDate(calculateEndDate(selectedFY.end_date));
                }
            }
            setSelectedName(currentFinacialYear)
            setFilterCheckBox([])
            setSelectedFilter('date_range')
        }
        getCount(type)
    }
    //----

    //Search Functions ----
    /**
     * The function `handleSearchParams` updates the search parameters by adding or modifying a key-value
     * pair, and then updates the state with the new search parameters.
     */
    const handleSearchParams = (key, value) => {
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value);}
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }
    /* The `optimizedFn` is a memoized version of the `Debounce` function that is used to debounce the
    `handleSearchParams` function. Debouncing is a technique used to limit the number of times a
    function is called by delaying its execution until after a certain amount of time has passed since
    the last time it was invoked. */
    const optimizedFn = useCallback(
        Debounce((key, value) => handleSearchParams(key,value)),
        [searchParams]
    );
    //----

    //API Calls----
    /* The above code is a JavaScript React function using the `useCallback` hook to make an API call to
    retrieve inventory issue report data. Here is a breakdown of what the code is doing: */
    const getGRNListAPICall = useCallback(async () => {
        if(searchParams?.get('search') === null){
            setsearchFieldDebounce('')
        }
        
        try {   
            setLoading(true)     
            const branch_id = await GetBranchId()
            let endDate1 = searchParams?.get('end_date') === null ? endDate.substring(0, 10): searchParams?.get('end_date');
            if (endDate1) {
                const parsedEndDate = new Date(endDate1);
                parsedEndDate.setDate(parsedEndDate.getDate() + 1);
                endDate1 = parsedEndDate.toISOString().split('T')[0];
            }
            let endpoint = `grn-entry/grn-list?filter=true&branch_id=${branch_id}&page=${
                searchParams?.get('page_number')===null ? '1' : searchParams?.get('page_number')}${
                searchParams?.get('search') === null ? '': `&search_term=${searchParams?.get('search')}` }${`${
                searchParams?.get('start_date') === null ?`&start_date=${startDate.substring(0, 10)}` : `&filter=true&start_date=${searchParams?.get('start_date')}`}${
                `&end_date=${endDate1}`}`}${
                searchParams?.get('sort') === null 
                    ? '' 
                    : `&sort=${encodeURIComponent(searchParams.get('sort'))}`
            }`
            const response = await dataService.GetAPI(endpoint)
            const temp = response?.data?.data?.grn_entries
            const temp2 = response?.data?.data?.filter_count
            const temp3 = response?.data?.data?.total_entries
            setGRNList(temp)
            setGRNListCount(temp2)
            setGRNListTotalCount(temp3)    
        } catch(error) {
            console.log(error)
            setLoading(false)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        } finally{
            setLoading(false)
            updateFilterCheckBox();
        }
    }, [searchParams, FYLoading]);

    /**
     * The function `getFinancialYears` retrieves financial years data from an API, sets the financial
     * years state, sets the current financial year state, and updates the search parameters.
     */
    const getFinancialYears = async() => {
        try {
            const branch_id = await GetBranchId()
            let endpoint = `financial-years?branch_id=${branch_id}&filter=true&status=open,closed,ongoing&sort=start_date%2Bdesc`
            const response = await dataService.GetAPI(endpoint)
            const temp1 = response?.data?.data?.financial_years
            setFinacialYear(temp1)
            const selectedFY = JSON.parse(localStorage.getItem('FY_details'));
            setCurrentFinacialYear(selectedFY.name)
            setSelectedName(searchParams?.get('main') !== null ? searchParams?.get('main') : selectedFY.name)
            const ongoingFYData = temp1.find(item => item.name === selectedFY.name);
            // If there's ongoing data, set the start and end dates in the state
            if (ongoingFYData) {
                setStartDate(ongoingFYData.start_date);
                setEndDate(calculateEndDate(ongoingFYData.end_date));
            }
        }
        catch (error) {
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        }
        finally {
            setFYLoading(false)
        }
        // setSearchParams({})
    }

    useEffect(()=>{
        getFinancialYears()
    },[])

    useEffect(() => {
        if (reloadFY) {
            handleApplyFilter(false)
            window.location.reload();
            setReloadFY(false);
        }
    }, [reloadFY]);

    //----

    /* The below code is using the `useEffect` hook in React to set up an interval that changes the
    placeholder index cyclically every 2 seconds. The `setPlaceholderIndex` function is used to update
    the state of the placeholder index based on the previous index value and the length of the
    `placeholderOptions` array. The interval is cleared when the component unmounts to prevent memory
    leaks. */
    useEffect(() => {
        const interval = setInterval(() => {
            // Change placeholder index cyclically
            setPlaceholderIndex(prevIndex => (prevIndex + 1) % placeholderOptions.length);
        }, 2000);

        return () => clearInterval(interval);
    }, []);

        
    /* The below code is using the `useEffect` hook in React to make an API call to
    `getGRNListAPICall` function. This API call is made when the component is mounted
    or when the `getGRNListAPICall` function changes. */
    useEffect(() => {
        //setsearchFieldDebounce(searchParams.get('search') !== null ? decodeURIComponent(searchParams.get('search')) : '')
        if (startDate != null && !FYLoading ){
            getGRNListAPICall()
        }
    }, [searchParams, startDate, FYLoading]);

    const calculateEndDate = (fyEndDate) => {
        const fyEndDate1 = new Date(fyEndDate);
        const currentDate = moment().endOf('day');
        return currentDate <= fyEndDate1 ? currentDate.toISOString() : fyEndDate;
    }

    return (
        <CardHeader noPadding>
            {/* top bar */}
            <div
                className="mainDataCntnrTop shadow-s13"
                style={{ position: "sticky", position: "-webkit-sticky"}}
            >
                <div className="flex justify-start">
                    <h5 class="pageHeader">
                        GRN Entries
                    </h5>
                </div> 
                <div className='flex items-center'>
                    <Search
                        SearchValue={searchFieldDebounce}
                        handleOnClickSearch={setsearchFieldDebounce}
                        optimizedFn={optimizedFn}
                        customSearchPlaceHolder={placeholderOptions[placeholderIndex]}
                    />
                    <div class="relative">
                        <button onClick={() => {
                            handleOpenFilter()

                        }} type="button" id="filter_btn">
                            <img loading="lazy" src="/images/Filter_Icon.svg" alt="img" class="w-[15px] h-[15px]"/>
                            <span class="text-f2 font-normal text-[#106EB4] pl-2.5">Filter</span>
                            {filterCount !== 0 && <p class="p-2 text-[14px] leading-[7px] font-semibold text-[#FFFFFF] ml-2 bg-[#106EB4] rounded-[50%]">{filterCount}</p>}
                        </button>
                        {isFilterOpen && 
                        <Filter 
                            ref={outSideClick}
                            filterCount={filterCount}
                            selectedDateRange={selectedDateRange}
                            setSelectedDateRange={setSelectedDateRange}
                            selectedName={selectedName}
                            setSelectedName={setSelectedName}
                            searchParams={searchParams}
                            currentFinacialYear={currentFinacialYear}
                            handleSelectObject={handleSelectObject}
                            FilterCheckbox={FilterCheckbox}
                            setFilterCheckBox={setFilterCheckBox}
                            FilterData={FilterData}
                            handleApplyFilter={handleApplyFilter}
                            setIsFilterOpen={setIsFilterOpen}
                            selectedFilter={selectedFilter}
                            setSelectedFilter={setSelectedFilter}
                            radioButton={true}
                            finacialYear={finacialYear}
                            setSearchParams={setSearchParams}
                            setStartDate={setStartDate}
                            setEndDate={setEndDate}
                            dateRangeDropdownOptions={[{ name: 'Financial Year' }, { name: 'Custom' }]}
                            calculateEndDate={calculateEndDate}
                        />}
                    </div>
                    {!isInactiveBranch &&
                    <Link to='/inventory-master/grn-entry/add-grn-entry' 
                        className="prmy-btn">
                        Add GRN Entry
                    </Link>}
                </div>
                {toastErrorMessage !== "" && (
                    <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage}
                    />
                )}
            </div>
            <div class="mainDataCntnrListDiv scrollBlue_thick">
                { loading 
                    ? <div ><Shimmer classkey={"mt-[32px]"}/></div>
                    : <Table GRNList={GRNList} setPageLoading={setLoading} searchParams={searchParams} setSearchParams={setSearchParams} startDate={startDate} endDate={endDate} GRNListCount={GRNListCount} handleOnClickSort={handleSearchParams} sortValue={searchParams.get('sort') || ''}/>}
            </div>
        </CardHeader>
    )
}

export default GRNList; 